<div class="modal-plate" *ngFor="let plate of listPlates; let i=index">
  <div class="plate-name">
    <span class="lic-plate">LP.</span>
    <span class="modal-lp-number">{{plate.licensE_PLATE}}</span>
  </div>
  <div class="view-detail">
    <img src="../../../../../assets/images/Icons/Eye.png" alt="">&nbsp;
    <span class="modal-view-multi" (click)=getDetail(plate)>View detail</span>
  </div>
</div>
